module.exports = __webpack_public_path__ + "static/media/login-bg@2x.3c6b1a68.png";